import { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useGetMaterialTypeQuery } from 'services/materialTypes'
import { useSelector } from 'react-redux'

const MaterialTypesDataFetcher = ({ materialTypeId, setCachedMaterialTypesData }) => {
  const { supplementalPriceSheetIds } = useSelector(state => state.materials)

  const getMaterialTypeByIdPayload = useMemo(() => {
    const payload = { materialTypeId }
    if (supplementalPriceSheetIds?.length > 0) {
      payload.filter = JSON.stringify({ supplementalPriceSheetIds })
    }
    return payload
  }, [materialTypeId, supplementalPriceSheetIds])

  const { data: materialTypeData } = useGetMaterialTypeQuery(getMaterialTypeByIdPayload)

  useEffect(() => {
    if (materialTypeData) {
      setCachedMaterialTypesData(prevState => ({
        ...prevState,
        [materialTypeId]: {
          ...materialTypeData,
          supplementalPriceSheetIds,
        },
      }))
    }
  }, [materialTypeData])

  return null
}

MaterialTypesDataFetcher.propTypes = {
  materialTypeId: PropTypes.string.isRequired,
  setCachedMaterialTypesData: PropTypes.func.isRequired,
}

export default MaterialTypesDataFetcher
